import axios from 'axios';
import { PropertyType } from '../../common';

export const api = axios.create({
	baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
	headers: {
		'Content-Type': 'application/json',
	},
});

export const setConfig = (data: PropertyType): PropertyType => ({
	headers: {
		Authorization: `Bearer ${data.token}`,
	},
});
